<template>
  <div class="work-hour">
    <div class="control-width mx-auto">
      <div class="p-4 p-md-5 border shadow-sm add-rounded">
        <h4
          class="mb-3 font-weight-bold kova-text"
        >How many hours of commitment will you require from your developer?</h4>
        <div class="text-left">
          <label for="opt1" class="radio text-left">
            <input type="radio" name="rdo" id="opt1" value="1" v-model="commitment" class="hidden" />
            <span class="label"></span>40 or more hrs/week (Full time)
          </label>
          <br />

          <label for="opt2" class="radio text-left">
            <input type="radio" name="rdo" id="opt2" value="2" v-model="commitment" class="hidden" />
            <span class="label"></span>Less than 40 hrs/week (Part time)
          </label>
          <br />

          <label for="opt3" class="radio text-left">
            <input type="radio" name="rdo" value="3" id="opt3" v-model="commitment" class="hidden" />
            <span class="label"></span>Hourly
          </label>
          <br />

          <label for="opt4" class="radio text-left">
            <input type="radio" name="rdo" value="4" v-model="commitment" id="opt4" class="hidden" />
            <span class="label"></span>Don't know yet
          </label>
          <br />
        </div>

        <div class="container-fluid px-0 px-md-4 mb-5 mt-4">
          <div class="row">
            <div class="col text-left">
              <button
                class="btn-outline-kovatek py-2 px-4 px-sm-5 btn-rounded"
                v-on:click="goBack"
              >Back</button>
            </div>
            <div class="col text-right">
              <button class="btn-kovatek py-2 px-4 px-sm-5 btn-rounded" v-on:click="next">Next</button>
            </div>
          </div>
        </div>
      </div>
      <div class="text-right kova-text pt-3 mr-4">
        <span @click="skip">
          Skip
          <font-awesome-icon icon="step-forward"></font-awesome-icon>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "job-work-hour",
  data() {
    return {
      commitment: this.$store.state.fcjob.fcjobData.commitment
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    next() {
      const { commitment } = this;
      this.$store.commit("fcjob/updateFcJob", {
        commitment
      });
      this.$router.push("job-expert-level");
    },
    skip() {
      this.$router.push("job-expert-level");
    }
  }
};
</script>
<style scoped>
.control-width {
  width: 600px;
}

@media (min-width: 768px) and (max-width: 991px) {
}
@media (max-width: 767px) {
  .control-width {
    width: 500px;
  }
}
@media (max-width: 550px) {
  .control-width {
    width: 98%;
  }
}
</style>
